import { RouteType } from "../enums/route-type";
import { BaseRoute } from "../models/base-routes";

const appConfig = () => {
  const getConfig = (activeRoute: BaseRoute) => {
      switch (activeRoute?.type) {
        case RouteType.Select:
            return {
              isSelect: true,
              isCommon: false
            };
        
        case RouteType.Common:
        return {
          isSelect: false,
          isCommon: true
        };

        case RouteType.Stream:
            return {
              isSelect: false,
              isCommon: false
            };

        default:
            return {
              isSelect: false
            };
      }
  }

  return { getConfig };
}

export default appConfig;